// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2zmZH","colCheckbox":"styles_colCheckbox__NZo-A"};